// const app_url = "https://glamhive-admin.invo.zone";
const app_url = "https://app.glamhive.com";

const getAuthToken = () => localStorage.getItem('Glamhive_Client_Auth_Token') || '';

const printError = (selector, errorMsg, status='error') => {
  const msg = String(errorMsg).replace(/^Error:\s+/, '');
  document.querySelector(selector).innerHTML = `
     <div class="${status == 'error' ? 'gm__error' : 'gm__success'}">${msg}</div>
  `;
};

async function sendRequest (route, options = {}) {
  options = {
    body: {},
    method: 'GET',
    authenticate: false,
    ...options,
  };
  route = route.replace(/^\/+/, '');

  const fetchOptions = {
    method: options.method.toUpperCase(),
    headers: {}
  };

  if (['POST', 'PUT', 'PATCH'].includes(fetchOptions.method)) {
    fetchOptions.body = options.body;
  }

  if (options.authenticate) {
    fetchOptions.headers['Authorization'] = `Bearer ${getAuthToken()}`;
  }

  try {
    const response = await fetch(`${app_url}/api/${route}`, fetchOptions);

    const json = await response.json();

    if (response.status !== 200) {
      return new Error(json?.message || 'Unable to fetch response from the given url');
    }

    return json?.data || json;
  } catch (e) {
    return e;
  }
}